import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { CONSTANTS } from '../../constants';

@Injectable({
    providedIn: 'root'
})

export class AppService extends ApiService {
    public getAppState() {
        return this.contGet(CONSTANTS.API.APP.APP_STATE);
    }
    public initApp(data: any) {
        return this.getContQueryParams(CONSTANTS.API.APP.INIT_APP, data);
    }
}
